import type { MiSolicitud, TipoDetalleSolicitud } from "@/lib/types";

/**
 * Qué muestra la fila expandible de «Mis solicitudes de pago» · el backend manda
 * `tipoDetalle` (regla única); si no viniera (respuesta vieja), se deriva con la
 * MISMA regla: invoice cargado → "Invoice"; facturas con acuse → "Facturas"; si no,
 * null (nada que mostrar → sin chevron).
 */
export function tipoDetalleDe(
  s: Pick<MiSolicitud, "tipoDetalle" | "tieneInvoice" | "numeroFacturas">,
): TipoDetalleSolicitud | null {
  if (s.tipoDetalle !== undefined) return s.tipoDetalle;
  if (s.tieneInvoice) return "Invoice";
  return (s.numeroFacturas ?? 0) > 0 ? "Facturas" : null;
}

/** Sustantivo del contenido expandible para etiquetas accesibles y botones ("Ver facturas"/"Ver invoice"). */
export function sustantivoDetalle(tipo: TipoDetalleSolicitud): string {
  return tipo === "Invoice" ? "invoice" : "facturas";
}

/** Tasa del impuesto del invoice como porcentaje legible · acepta fracción (0.16) o porcentaje (16). */
export function formatearTasa(tasa: number | null | undefined): string | null {
  if (tasa === null || tasa === undefined) return null;
  const pct = tasa <= 1 ? tasa * 100 : tasa;
  return `${Number(pct.toFixed(2)).toLocaleString("es-MX", { maximumFractionDigits: 2 })}%`;
}

/** Indicador de impuesto SAP derivado de la tasa del invoice (V0/V5/V7…) · lo manda el backend. */
export interface IndicadorImpuestoResumen {
  codigo: string;
  tasaOCuota: number;
  descripcion: string;
}

/** Texto del tooltip del chip del indicador: "V5 · 16% · IVA tasa general 16%" (sin partes vacías). */
export function textoTooltipIndicador(ind: IndicadorImpuestoResumen): string {
  return [ind.codigo, formatearTasa(ind.tasaOCuota), ind.descripcion?.trim() || null].filter(Boolean).join(" · ");
}
